import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes'
import 'instant.page'

import './header.js'

import './modules/accordions.js'
import './modules/block-links.js'
import './modules/card-slider.js'
import './modules/dialog-modal.js'
import './modules/external-links.js'
import './modules/header.js'
import './modules/icon-cloud.js'
import './modules/image-callout.js'
import './modules/image-carousel.js'
import './modules/images.js'
import './modules/jump-links.js'
import './modules/nav-drawer.js'
import './modules/notice-bar.js'
import './modules/search-overlay.js'
import './modules/skip-links.js'
import './modules/slideshow-hero.js'
import './modules/sticky-manager.js'
import './modules/print-feature.js'
import './modules/appointment.js'
import './modules/scroll-to-top.js'
import './modules/event-calendar.js'
import './testimonial-slider.js'
import './modules/video-play-button.js'
import { openModal } from './modules/modal.js'

document.querySelectorAll('button[data-modal-target]').forEach(btn => {
    btn.addEventListener('click', (e) => openModal(btn.dataset.modalTarget, e.currentTarget))
})
